import dayjs from "@/lib/dayjs";

import { addDate } from "../add/add-date";
import { formatDate } from "../format-date";

type Props = {
	startDate: string;
	endDate: string;
};

export function getDateRangeArray({ startDate, endDate }: Props): Array<string> {
	const dateArray: Array<string> = [];
	if (startDate > endDate) return dateArray;

	let currentDate = dayjs(startDate);
	const stopDate = dayjs(endDate);
	while (currentDate <= stopDate) {
		dateArray.push(formatDate(currentDate.toString()));
		currentDate = dayjs(addDate({ date: currentDate.toString(), inc: 1 }));
	}
	return dateArray;
}
